import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Button, Spin } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAdd } from '@fortawesome/pro-solid-svg-icons/faAdd'
import { faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons/faTriangleExclamation'
import { useAppDispatch, useAppSelector } from 'store/hooks'
import { CourseStateType } from 'enum/course-state.enum'
import { slices } from 'store/slices'
import Collections from './collections'
import Prerequisites from './prerequisites'
import { Title } from './../styled'
import {
  CreateCollection,
  Description,
  Alert,
  AlertTitle,
  AlertDescription,
} from './styled'

const Content = () => {
  const { t } = useTranslation()
  const prefix = 'administration.learningPaths.manage.create.content'
  const dispatch = useAppDispatch()
  const [coursesInDraft, setCoursesInDraft] = useState(0)
  const content = useAppSelector(slices.learningPath.content)
  const loadingContent = useAppSelector(slices.learningPath.loadingContent)

  useEffect(() => {
    let courseCounter = 0
    for (const collection of content.collections) {
      for (const relatedCourse of collection.relatedCourses) {
        if (relatedCourse.course.state === CourseStateType.Draft) {
          courseCounter += 1
        }
      }
    }
    setCoursesInDraft(courseCounter)
  }, [content.collections])

  return (
    <Spin spinning={loadingContent}>
      <Title>{t(`${prefix}.title`)}</Title>
      <CreateCollection>
        <Button
          onClick={() => dispatch(slices.learningPath.addEmptyCollection())}
          type="link"
        >
          <FontAwesomeIcon icon={faAdd} />
          {t(`${prefix}.buttons.createCollection`)}
        </Button>
      </CreateCollection>
      <Description>
        {t(`${prefix}.description`)}
        <a
          href="https://rankmi-support.freshdesk.com/es/support/solutions/articles/72000626839-antes-de-partir"
          target="_blank"
        >
          {t(`${prefix}.descriptionSuffix`)}
        </a>
        .
      </Description>
      {coursesInDraft > 0 && (
        <Alert>
          <FontAwesomeIcon icon={faTriangleExclamation} />
          <AlertTitle>
            {t(`${prefix}.alert.title`).replace(
              '{coursesInDraft}',
              coursesInDraft.toString()
            )}
          </AlertTitle>
          <AlertDescription>
            {`${t(`${prefix}.alert.description`)} `}
            <a onClick={() => window.open('/administration/courses')}>
              {t(`${prefix}.alert.link`)}
            </a>
            {` ${t(`${prefix}.alert.descriptionSuffix`)}`}
          </AlertDescription>
        </Alert>
      )}
      <Collections />
      <Prerequisites />
    </Spin>
  )
}

export default Content
